import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import * as moment from 'moment-timezone';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';

@Component({
  templateUrl: './park-notifications-form.html',
  selector: 'park-notifications-form'
})
export class ParkNotificationsFormComponent implements OnInit {
  @Input() parkId: string;
  @Input() getSearchStatus: boolean;
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  @Input() settings;

  inProgress = false;

  public notificationsForm: FormGroup;

  constructor(private http: HttpClient, private auth: AuthenticationService, private urlHelper: UrlHelper) {
    this.notificationsForm = new FormGroup({
      is_maintenance: new FormControl('', Validators.required),
      is_alarms: new FormControl('', Validators.required),
      send_daily_report_time: new FormControl('', Validators.required),
    });
  }

  public setViewMode() {
    this.getSearchStatusChange.emit(false);
  }

  onSubmit({value, valid}) {
    if (valid) {

      const data = {
        data: {
          type: 'Notifications',
          attributes: {
            is_maintenance: Boolean(parseInt(value.is_maintenance, 10)),
            is_alarms: Boolean(parseInt(value.is_alarms, 10)),
            send_daily_report_time: moment(value.send_daily_report_time).format('HH:mm'),
            send_daily_report_timezone: moment.tz.guess(),
          }
        }
      };

      this.inProgress = true;

      const url = `${this.urlHelper.getPrefix()}/parks/${this.parkId}/notifications`;

      this.http.post(url, data).subscribe(
        (res: any) => {
          this.inProgress = false;
          Object.assign(this.settings, res.data);
          this.setViewMode();
        },
        (err) => {
          this.inProgress = false;
          console.log(err);
        },
        () => {
          this.inProgress = false;
        });
    }
  }

  ngOnInit() {
    if (this.settings !== null && this.settings.hasOwnProperty('attributes')) {
      this.notificationsForm.patchValue({
        is_maintenance: this.settings.attributes.is_maintenance ? '1' : '0',
        is_alarms: this.settings.attributes.is_alarms ? '1' : '0',
        send_daily_report_time: moment(this.settings.attributes.send_daily_report_time, 'HH:mm').toISOString(),
      });
    } else {
      this.notificationsForm.patchValue({
        is_maintenance: '0',
        is_alarms: '0',
        send_daily_report_time: moment('12:00', 'HH:mm').toISOString(),
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/forms/park-notifications-form/park-notifications-form.component.ts